<section class="atw-page create-job-page" [attr.dir]="isAr ? 'rtl' : 'ltr'">
  <span class="shape shape-1"></span>
  <span class="shape shape-2"></span>
  <span class="dots dots-left"></span>
  <span class="dots dots-right"></span>

  <div class="atw-container">
    <div class="section-title create-job-title">
      <span>
        <b>{{ 'atw.createJob.sectionNumber' | transloco }}</b>
      </span>

      <div>
        <h2>{{ 'atw.createJob.title' | transloco }}</h2>
        <p>{{ 'atw.createJob.subtitle' | transloco }}</p>
      </div>
    </div>

    <div class="apply-card loading-card" *ngIf="!contentReady">
      {{ 'atw.createJob.loading' | transloco }}
    </div>

    <form
      *ngIf="contentReady"
      class="apply-card create-job-card"
      [formGroup]="data"
      (ngSubmit)="handleSubmit()"
    >
      <div class="success-message" *ngIf="successMessage">
        {{ successMessage }}
      </div>

      <div class="error-message" *ngIf="errorMessage">
        {{ errorMessage }}

        <ul class="validation-list" *ngIf="validationErrors.length">
          <li *ngFor="let error of validationErrors">
            {{ error }}
          </li>
        </ul>
      </div>

      <div class="create-job-stepper" *ngIf="activeSteps.length > 1">
        <ng-container *ngFor="let step of activeSteps; let last = last">
          <button
            type="button"
            class="step-pill"
            [class.active]="isStepActive(step)"
            [class.done]="isStepDone(step)"
            (click)="goToStep(step)"
          >
            <span>{{ activeSteps.indexOf(step) + 1 }}</span>
            {{ getStepLabel(step) }}
          </button>

          <span class="step-line" *ngIf="!last"></span>
        </ng-container>
      </div>

      <ng-container *ngIf="currentStep === 'jobTitle'">

      <!-- Basic Info -->
      <div class="create-job-block">
        <div class="box-title">
          <img class="img-m" src="assets/as/4.webp" alt="basic info" />
          <h3>{{ 'atw.createJob.basicInfo' | transloco }}</h3>
        </div>

        <div class="form-grid">
          <label>
            <span>{{ 'atw.createJob.titleAr' | transloco }}</span>
            <input
              type="text"
              formControlName="title_ar"
              [placeholder]="'atw.createJob.titleArPlaceholder' | transloco"
            />
            <small class="field-error" *ngIf="isInvalid('title_ar')">
              {{ 'atw.createJob.requiredField' | transloco }}
            </small>
          </label>

          <label>
            <span>{{ 'atw.createJob.titleEn' | transloco }}</span>
            <input
              type="text"
              formControlName="title_en"
              [placeholder]="'atw.createJob.titleEnPlaceholder' | transloco"
            />
            <small class="field-error" *ngIf="isInvalid('title_en')">
              {{ 'atw.createJob.requiredField' | transloco }}
            </small>
          </label>
        </div>
      </div>

      <div class="create-job-block">
        <div class="box-title">
          <img class="img-m" src="assets/as/6.webp" alt="location" />
          <h3>{{ isAr ? 'المكان ونوع الوظيفة' : 'Location and job type' }}</h3>
        </div>

        <div class="form-grid">

          <label>
            <span>{{ 'atw.createJob.country' | transloco }}</span>
            <select formControlName="country_id" (change)="onCountryChange()">
              <option [ngValue]="null">
                {{ 'atw.createJob.selectCountry' | transloco }}
              </option>

              <option
                *ngFor="let country of countries; trackBy: trackById"
                [ngValue]="country.id"
              >
                {{ getCountryName(country) }}
              </option>
            </select>
            <small class="field-error" *ngIf="isInvalid('country_id')">
              {{ 'atw.createJob.requiredField' | transloco }}
            </small>
          </label>

          <label>
            <span>{{ 'atw.createJob.city' | transloco }}</span>
            <select formControlName="city_id" [disabled]="!cities.length">
              <option [ngValue]="null">
                {{ 'atw.createJob.selectCity' | transloco }}
              </option>

              <option
                *ngFor="let city of cities; trackBy: trackById"
                [ngValue]="city.id"
              >
                {{ getCityName(city) }}
              </option>
            </select>
            <small class="field-error" *ngIf="isInvalid('city_id')">
              {{ 'atw.createJob.requiredField' | transloco }}
            </small>
          </label>

          <label>
            <span>{{ 'atw.createJob.workModel' | transloco }}</span>
            <select formControlName="work_model">
              <option *ngFor="let item of workModels" [value]="item.value">
                {{ item.labelKey | transloco }}
              </option>
            </select>
          </label>

          <label>
            <span>{{ 'atw.createJob.employmentType' | transloco }}</span>
            <select formControlName="employment_type">
              <option *ngFor="let item of employmentTypes" [value]="item.value">
                {{ item.labelKey | transloco }}
              </option>
            </select>
          </label>

          <label>
            <span>{{ isAr ? 'فئة المتقدمين' : 'Applicant Category' }}</span>
            <select formControlName="job_type">
              <option *ngFor="let item of jobTypes" [value]="item.value">
                {{ isAr ? item.labelAr : item.labelEn }}
              </option>
            </select>
          </label>
        </div>
      </div>

      </ng-container>

      <ng-container *ngIf="currentStep === 'jobDetails'">

      <!-- Description -->
      <div class="create-job-block">
        <div class="box-title">
          <img class="img-m" src="assets/as/12.webp" alt="description" />
          <h3>{{ 'atw.createJob.descriptionSection' | transloco }}</h3>
        </div>

        <div class="form-grid">
          <label class="full">
            <span>{{ 'atw.createJob.description' | transloco }}</span>
            <textarea
              formControlName="description"
              [placeholder]="'atw.createJob.descriptionPlaceholder' | transloco"
            ></textarea>
            <small class="field-error" *ngIf="isInvalid('description')">
              {{ 'atw.createJob.requiredField' | transloco }}
            </small>
          </label>

          <label class="full">
            <span>{{ 'atw.createJob.responsibilities' | transloco }}</span>
            <textarea
              formControlName="responsibilities"
              [placeholder]="'atw.createJob.responsibilitiesPlaceholder' | transloco"
            ></textarea>
          </label>
        </div>
      </div>

      <!-- Salary -->
      <div class="create-job-block">
        <div class="box-title">
          <img class="img-m" src="assets/as/28.webp" alt="salary" />
          <h3>{{ 'atw.createJob.salarySection' | transloco }}</h3>
        </div>

        <div class="form-grid">
          <label>
            <span>{{ 'atw.createJob.salaryType' | transloco }}</span>
            <select formControlName="salary_type">
              <option *ngFor="let item of salaryTypes" [value]="item.value">
                {{ item.labelKey | transloco }}
              </option>
            </select>
          </label>

          <label>
            <span>{{ 'atw.createJob.currency' | transloco }}</span>
            <select formControlName="salary_currency">
              <option *ngFor="let currency of currencies" [value]="currency">
                {{ currency }}
              </option>
            </select>
          </label>

          <label>
            <span>{{ isAr ? 'اسم العملة بالعربية' : 'Currency Name in Arabic' }}</span>
            <input
              type="text"
              formControlName="salary_currency_ar"
              maxlength="50"
              [placeholder]="isAr ? 'مثال: ريال سعودي' : 'Example: ريال سعودي'"
            />
          </label>

          <label>
            <span>{{ 'atw.createJob.salaryMin' | transloco }}</span>
            <input type="number" formControlName="salary_min" min="0" />
          </label>

          <label>
            <span>{{ 'atw.createJob.salaryMax' | transloco }}</span>
            <input type="number" formControlName="salary_max" min="0" />
          </label>

          <label class="full">
            <span>{{ 'atw.createJob.salaryNote' | transloco }}</span>
            <input
              type="text"
              formControlName="salary_note"
              [placeholder]="'atw.createJob.salaryNotePlaceholder' | transloco"
            />
          </label>
        </div>
      </div>

      <!-- Assessments -->
      <div class="create-job-block">
        <div class="box-title">
          <img class="img-m" src="assets/as/27.webp" alt="assessments" />
          <h3>{{ 'atw.createJob.assessmentsSection' | transloco }}</h3>
        </div>

        <div class="create-job-checks">
          <label class="check-card">
            <input type="checkbox" formControlName="exam_required" />
            <span></span>
            <div>
              <strong>{{ 'atw.createJob.examRequired' | transloco }}</strong>
              <small>{{ 'atw.createJob.examRequiredHint' | transloco }}</small>
            </div>
          </label>

          <label class="check-card">
            <input type="checkbox" formControlName="personality_assessment_required" />
            <span></span>
            <div>
              <strong>{{ 'atw.createJob.personalityRequired' | transloco }}</strong>
              <small>{{ 'atw.createJob.personalityRequiredHint' | transloco }}</small>
            </div>
          </label>
        </div>
      </div>

      <!-- Skills -->
      <div class="create-job-block">
        <div class="box-title">
          <img class="img-m" src="assets/as/17.webp" alt="skills" />
          <h3>{{ 'atw.createJob.skillsSection' | transloco }}</h3>
        </div>

        <div class="skill-tabs">
          <button
            type="button"
            class="skill-tab"
            *ngFor="let category of skillCategories"
            [class.active]="selectedSkillCategory === category.value"
            (click)="selectSkillCategory(category.value)"
          >
            {{ category.labelKey | transloco }}
          </button>
        </div>

        <div class="skills-list" *ngIf="filteredSkills.length; else noSkills">
          <label
            class="skill-chip-check"
            *ngFor="let skill of filteredSkills; trackBy: trackById"
          >
            <input
              type="checkbox"
              [checked]="isSkillSelected(skill.id)"
              (change)="toggleSkill(skill.id, $event)"
            />
            <span>{{ getSkillName(skill) }}</span>
          </label>
        </div>

        <ng-template #noSkills>
          <div class="empty-state">
            {{ 'atw.createJob.noSkills' | transloco }}
          </div>
        </ng-template>

        <div class="selected-skills" *ngIf="selectedSkills.length">
          <strong>{{ 'atw.createJob.selectedSkills' | transloco }}</strong>

          <div class="keyword-list">
            <span *ngFor="let skill of selectedSkills; trackBy: trackById">
              {{ getSkillName(skill) }}
            </span>
          </div>
        </div>
      </div>

      <!-- Requirements -->
      <div class="create-job-block">
        <div class="box-title requirements-head">
          <div>
            <img class="img-m" src="assets/as/35.webp" alt="requirements" />
            <h3>{{ 'atw.createJob.requirementsSection' | transloco }}</h3>
          </div>

          <button type="button" class="secondary-action small-action" (click)="addRequirement()">
            <img class="img-m" src="assets/as/10.webp" alt="add" />
            {{ 'atw.createJob.addRequirement' | transloco }}
          </button>
        </div>

        <div formArrayName="requirements" class="requirements-list">
          <div
            class="requirement-card"
            *ngFor="let requirement of requirements.controls; let i = index; trackBy: trackByIndex"
            [formGroupName]="i"
          >
            <div class="form-grid requirement-grid">
              <label class="full">
                <span>{{ 'atw.createJob.requirementText' | transloco }}</span>
                <textarea
                  formControlName="requirement_text"
                  [placeholder]="'atw.createJob.requirementPlaceholder' | transloco"
                ></textarea>
              </label>

              <label>
                <span>{{ 'atw.createJob.requirementType' | transloco }}</span>
                <select formControlName="requirement_type">
                  <option *ngFor="let type of requirementTypes" [value]="type.value">
                    {{ type.labelKey | transloco }}
                  </option>
                </select>
              </label>

              <label class="switch-field">
                <input type="checkbox" formControlName="is_required" />
                <span>{{ 'atw.createJob.isRequired' | transloco }}</span>
              </label>
            </div>

            <button
              type="button"
              class="remove-file requirement-remove"
              [disabled]="requirements.length === 1"
              (click)="removeRequirement(i)"
            >
              ×
            </button>
          </div>
        </div>
      </div>

      </ng-container>

      <ng-container *ngIf="currentStep === 'account'">
        <div class="create-job-block onboarding-block" [formGroup]="accountForm">
          <div class="box-title">
            <img class="img-m" src="assets/as/4.webp" alt="account" />
            <h3>{{ isAr ? 'بيانات الحساب' : 'Account details' }}</h3>
          </div>

          <div class="form-grid">
            <label>
              <span>{{ isAr ? 'اسم الشركة' : 'Company name' }}</span>
              <input
                type="text"
                formControlName="company_name"
                [placeholder]="isAr ? 'مثال: Google' : 'Example: Google'"
              />
              <small class="field-error" *ngIf="isAccountInvalid('company_name')">
                {{ 'atw.createJob.requiredField' | transloco }}
              </small>
            </label>

            <label>
              <span>{{ isAr ? 'اسم الشركة بالعربي' : 'Arabic company name' }}</span>
              <input
                type="text"
                formControlName="company_name_ar"
                [placeholder]="isAr ? 'اسم الشركة بالعربي' : 'Arabic name'"
              />
            </label>

            <label>
              <span>{{ isAr ? 'رقم الموبايل' : 'Mobile number' }}</span>
              <input
                type="tel"
                formControlName="phone"
                [placeholder]="isAr ? 'رقم الموبايل' : 'Mobile number'"
              />
              <small class="field-error" *ngIf="isAccountInvalid('phone')">
                {{ 'atw.createJob.requiredField' | transloco }}
              </small>
            </label>

            <label>
              <span>{{ isAr ? 'البريد الإلكتروني' : 'Email' }}</span>
              <input
                type="email"
                formControlName="email"
                [placeholder]="isAr ? 'البريد الإلكتروني' : 'Email address'"
              />
              <small class="field-error" *ngIf="isAccountInvalid('email')">
                {{ isAr ? 'البريد الإلكتروني غير صحيح' : 'Invalid email address' }}
              </small>
            </label>
            <label>
              <span>{{ isAr ? 'التخصص' : 'Specialty' }}</span>
              <input
                type="text"
                formControlName="specialty"
                [placeholder]="isAr ? 'مثال: توظيف وتقنية' : 'Example: Recruitment and tech'"
              />
            </label>

            <label>
              <span>{{ isAr ? 'المجال' : 'Industry' }}</span>
              <input
                type="text"
                formControlName="industry"
                [placeholder]="isAr ? 'مجال الشركة' : 'Company industry'"
              />
            </label>

            <label class="full">
              <span>{{ isAr ? 'العنوان' : 'Address' }}</span>
              <input
                type="text"
                formControlName="address"
                [placeholder]="isAr ? 'عنوان الشركة' : 'Company address'"
              />
            </label>

            <label>
              <span>Facebook</span>
              <input type="url" formControlName="facebook" placeholder="https://facebook.com/..." />
            </label>

            <label>
              <span>LinkedIn</span>
              <input type="url" formControlName="linkedin" placeholder="https://linkedin.com/..." />
            </label>
          </div>
        </div>
      </ng-container>

      <div class="form-actions">
        <button type="submit" class="submit-btn" [disabled]="isSubmitting">
          <i *ngIf="isSubmitting">…</i>
          {{ getPrimaryActionLabel() }}
        </button>

        <button
          type="button"
          class="secondary-action"
          routerLink="/jobs"
          *ngIf="!canGoBack()"
        >
          {{ 'atw.createJob.cancel' | transloco }}
        </button>

        <button
          type="button"
          class="secondary-action"
          *ngIf="canGoBack()"
          (click)="goBack()"
        >
          {{ isAr ? 'رجوع' : 'Back' }}
        </button>
      </div>
    </form>
  </div>
</section>
